import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToolbarSinister } from "../../../shared/components/toolbarSinister/toolbarSinister";
import { LayoutBaseDePagina } from "../../../shared/layouts";
import { globalMaskDocument } from "../../../shared/utils";
import { useGetSinisterDetails } from "../../sinister/hooks/useGetSinisterDetails";
import { useSinisterSummary } from "../../sinister/hooks/useSinisterSummary";
import { useTotalLmi } from "../../sinister/hooks/useTotalLMI";
import SinisterCardData from "../../sinister/components/SinisterCardData/SinisterCardData";
import { ModalSinisterValues } from "./Modals/ModalSinisterValues";

export const CreditRecoveryDetailsPresentation: React.FC = () => {
	const { id = "novo" } = useParams<"id">();
	const navigate = useNavigate();
	const { data: rows, isLoading, refetch: fetchSinisterDetails } = useGetSinisterDetails(id);
	const { responsibleName, totalBordero, rowSummary } = useSinisterSummary(id);
	const { data: totalLmi } = useTotalLmi(id, [rowSummary]);
	const [openValuesModal, setOpenValuesModal] = useState(false);

	useEffect(() => {
		if (id && id !== "novo") {
			fetchSinisterDetails();
		}
	}, [id]);

	return (
		<LayoutBaseDePagina
			titulo="Cobrança"
			subtitulo={`Detalhes do Sinistro [ ${rows?.proposal?.name ?? "N/D"} - ${globalMaskDocument(rows?.proposal?.document ?? "")} ]`}
			barraDeFerramentas={
				<ToolbarSinister
					clickButtonBack={() => navigate("/sinistros/cobranca")}
					showButtonDocument={false}
					showButtonResponsible={false}
					showButtonValid={false}
					showButtonConfirm={false}
					showButtonFinish={false}
					showButtonFollowUp={false}
					showButtonValues
					textButtonValues="Ver Valores"
					clickButtonValues={() => setOpenValuesModal(true)}
					showButtonBackLoading={isLoading}
					showButtonValuesLoading={isLoading}
				/>
			}
		>
			<Grid container gap={1} sx={{ width: "100%", maxWidth: "1300px" }}>
				{rows && (
					<SinisterCardData
						row={rows}
						responsibleName={responsibleName}
						totalBordero={totalBordero}
						sumLmi={
							totalLmi ?? {
								lmiTotal: "",
								saldo: "",
								valor: 0,
								valorAprovado: 0,
							}
						}
						showUpdateStatus={false}
						showUpdateProperty={false}
					/>
				)}
			</Grid>

			<ModalSinisterValues open={openValuesModal} sinisterId={id} onClose={() => setOpenValuesModal(false)} />
		</LayoutBaseDePagina>
	);
};
